/* eslint-disable no-void */

import { cache } from 'react';
import type { TReviewsData } from 'types/testFreaks';

import { envConfig } from '@/config/env';

export const addProductReviews = cache(
    async ({
        productId,
        variantId,
        comment,
        score = '1',
        market,
    }: {
        productId: string;
        variantId?: string;
        comment: string;
        score: string;
        market: string;
    }) => {
        let data: { error: null | boolean; data: TReviewsData } | null = null;

        let clientId;
        if (market === 'se')
            clientId = envConfig.NEXT_PUBLIC_SE_TESTFREAKS_CLIENT_ID;
        if (market === 'no')
            clientId = envConfig.NEXT_PUBLIC_NO_TESTFREAKS_CLIENT_ID;
        if (market === 'dk')
            clientId = envConfig.NEXT_PUBLIC_DK_TESTFREAKS_CLIENT_ID;
        if (market === 'fi')
            clientId = envConfig.NEXT_PUBLIC_FI_TESTFREAKS_CLIENT_ID;
        if (market === 'de')
            clientId = envConfig.NEXT_PUBLIC_EU_TESTFREAKS_CLIENT_ID;
        if (market === 'be')
            clientId = envConfig.NEXT_PUBLIC_EU_TESTFREAKS_CLIENT_ID;
        if (market === 'nl')
            clientId = envConfig.NEXT_PUBLIC_EU_TESTFREAKS_CLIENT_ID;
        if (market === 'at')
            clientId = envConfig.NEXT_PUBLIC_EU_TESTFREAKS_CLIENT_ID;
        if (market === 'fr')
            clientId = envConfig.NEXT_PUBLIC_EU_TESTFREAKS_CLIENT_ID;
        if (market === 'es')
            clientId = envConfig.NEXT_PUBLIC_EU_TESTFREAKS_CLIENT_ID;

        try {
            const response = await fetch('/api/reviews', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    client_id: clientId,
                    api_key: process.env.NEXT_PUBLIC_TESTFREAKS_API_KEY,
                    ...(!variantId && {
                        product_id: productId,
                    }),
                    ...(variantId && {
                        product_id: variantId,
                        product_site_id: productId,
                    }),
                    score,
                    content: comment,
                    market,
                }),
            });

            if (response.ok) {
                data = await response.json();
            }
        } catch (e: any) {
            console.error(e, 'failed submit product reviews');
        }

        return data;
    },
);

export const preload = (productId: string, comment: string, score: string) => {
    void addProductReviews({ productId, comment, score, market: '' });
};
